
        var result = require("!!../../../../node_modules/css-loader/index.js!./home.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./app/components/home/home.component.css
// module id = 1421
// module chunks = 0